import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { faDiscord } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button } from 'src/system/ui/button/Button'
import { discordColors } from 'src/system/ui/game-colors/brand'
import { AbsoluteLink } from 'src/system/ui/link/AbsoluteLink'

export function DiscordButton(props: { onClick?: () => void }) {
  const { t } = useTranslation()
  return (
    <StyledLink newTab to={t('social:discord:link')} disableStyles>
      <StyledButton
        onClick={props.onClick}
        color={discordColors.blurple}
        darkenOnHover
      >
        <FontAwesomeIcon icon={faDiscord} size='lg' />
        {t('discord_panel:action')}
      </StyledButton>
    </StyledLink>
  )
}

const StyledLink = styled(AbsoluteLink)`
  position: relative;
  z-index: 2;
`

const StyledButton = styled(Button)`
  svg {
    margin-right: ${(props) => props.theme.d.spacing[3]};
  }
`
